export default () => (next) => (action) => {
  if (action && action?.type === 'REMOVE_NO_CACHE_COOKIE') {
    document.cookie = `jp_nocache=false; path=/; secure=true; hostOnly=false;`;
    // Reload path and remove any query params
    window.location = window.location.pathname;
  }

  return next(action);
};
